import { Typography } from "antd";
import { stat } from "fs";
const { Text } = Typography;
interface FailPassTagProps {
  result: string;
}
export default function FailPassTag({ result }: FailPassTagProps) {
  let declaredResult: string = "Not Declared";
  const status = result?.toLowerCase();
  let tagBg = "#333";
  if (!result) {
    tagBg = "#ccc";
    declaredResult = "Not attempted"
  }else if (status === "pass" || status === "fail") {
    declaredResult = status;
    tagBg = status === "pass" ? "#52C41A" : "#FF4D4F";
  }
  return (
    <Text
      style={{
        padding: "5px 10px",
        borderRadius: "15px",
        color: "#fff",
        backgroundColor: tagBg,
        textTransform: "capitalize",
      }}
      type="success"
    >
      {declaredResult}
    </Text>
  );
}
